import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I'm a pro blogger now!",
  "description": "",
  "published": "2012-03-01T00:00:00.000Z",
  "redirect_from": ["/blog/im-a-pro-blogger-now/swizec/3797"],
  "categories": "Add-ons, blog, Uncategorized, WordPress, Zemanta",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Late January `}<a parentName="p" {...{
        "href": "http://twitter.com/andraz"
      }}>{`@andraz`}</a>{` approached me with an idea: What if I helped `}<a parentName="p" {...{
        "href": "http://www.zemanta.com",
        "title": "Zemanta"
      }}>{`Zemanta`}</a>{` spruce up `}<a parentName="p" {...{
        "href": "http://www.zemanta.com/fruitblog/"
      }}>{`their tech blog`}</a>{`?`}</p>
    <p>{`The blog had been languishing in neglect for a long time. An update every couple of months, completely random and with no real direction or purpose. Since they're a company that's all about `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Blog",
        "title": "Blog"
      }}>{`blogging`}</a>{` I guess it didn't look good to have a dead blog on their domain ...`}</p>
    <p>{`Now, I'd never blogged professionally and the whole prospect seemed a bit scary at first. It's one thing to arse about on your own blog and something completely different to ask for money and then be at a loss for words.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/a_stats.png",
        "alt": "Post stats",
        "title": "Post stats"
      }}></img></p>
    <p>{`The arrangement is pretty simple: Zemanta provides cool stories - I write two posts a month and whore them out on appropriate social networks.`}</p>
    <p>{`Two posts so far and everything went better than expected!`}</p>
    <p>{`The first got about four thousand pageviews to a blog that was previously getting ten people a day. The second post got about `}<strong parentName="p">{`15,000`}</strong>{`! Smashing success! And I actually think the score could be a lot higher had their server not melted.`}</p>
    <p>{`It wasn't easy though, each of those posts took four to five hours of research and writing - and that's not even counting the work it took to build my writing to where it doesn't smack people in the face and make them leave (too much)`}</p>
    <p>{`But the research is most fun!`}</p>
    <p>{`I get free range to pick developer's brains, pretend I understand what the hell they're talking about, then spend hours getting up to speed online and in the end dump that research into a story. And it does have to be a story!`}</p>
    <p>{`Nobody wants to read a dry technology report ... well, some do, but they aren't deterred by a good story ... And there's just enough Thompson in my blogging that I keep referring to Zemanta in the third person on their own blog; which looks a bit weird.`}</p>
    <p>{`Honestly, it just makes me giggle like a school girl that anyone would `}<em parentName="p">{`pay`}</em>{` me to write blogs. It's marvelous!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mommabethyname.com/2012/02/01/come-visit-me-at-zemanta/"
        }}>{`Come Visit Me at Zemanta`}</a>{` (mommabethyname.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dialogueofprayers.wordpress.com/2011/12/01/chrome-and-zemanta/"
        }}>{`Chrome and Zemanta`}</a>{` (dialogueofprayers.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.zemanta.com/blog/is-zemanta-your-little-blogging-secret/"
        }}>{`Is Zemanta your little blogging secret?`}</a>{` (zemanta.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=d4dd2885-f909-4e8e-af7b-37a55dd1cf1e",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      